import React, { useEffect, useState, useLayoutEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Form from './Form/Form';
import { get_showroom_agencies, get_showroom_details, get_timetable_detail } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class EditTimetable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            is_special: 0,
            timeslot: null,
            property_id: null,
            agencies: null,
            property: null,
            data: null

        };
        console.log(props);
    }

    async get_timeslot() {
        var data = await get_timetable_detail({ timeslot_id: this.props.match.params.id });
        if (data) {
            this.setState({
                ...this.state,
                property_id: data.property_id,
                timeslot: data
            }, () => {

                this.get_agencies();
                this.get_property();
            });
        } else {
            console.log(data);
        }
    }

    async get_property() {
        var data = await get_showroom_details(this.state.timeslot.property_id);
        if (data) {
            this.setState({
                ...this.state,
                property: data
            });
            this.format_data()

        } else {
            console.log(data);
        }
    }

    format_data() {
        let data = {
            type: this.state.timeslot.type,
            day: this.state.timeslot.day,
            is_special: this.state.timeslot.is_special,
            start_time: this.state.timeslot.start_time,
            end_time: this.state.timeslot.end_time,
            timeslot_id: this.state.timeslot.timeslot_id,
            property_id: this.state.property_id,
            date: this.state.timeslot.special_date,
            title: this.state.timeslot.special_title
        }

        for (let i = 0; i < this.state.timeslot.agencies.length; i++) {
            data['agency_slot_' + this.state.timeslot['agencies'][i].agency_id] = parseInt(this.state.timeslot['agencies'][i].max_appointment);
        }
        this.state.data = data;
    }

    async get_agencies() {
        var data = await get_showroom_agencies(this.state.property_id);
        if (data) {
            this.setState({
                ...this.state,
                agencies: data
            });
            this.format_data()

        } else {
            console.log(data);
        }
    }
    async componentWillMount() {
        this.get_timeslot();
    }

    render() {
        return (
            <div className={clsx(this.props.classes.root, this.props.className)} >
                {
                    this.state.property && this.state.timeslot && this.state.agencies ?

                        <Form
                            is_special={this.state.is_special}
                            timeslot={this.state.timeslot}
                            showroom_id={this.state.property_id}
                            showroom_agencies={this.state.agencies}
                            max_pax={this.state.property.max_pax}
                            max_appointment={this.state.property.max_appointment}
                            prevalues={this.state.data}
                        />
                        : ''}
            </div>
        )
    }

}
